import * as Routes from '../constants/routes';
import { trackingEvent } from '../helpers/tracking';

import Intro from '../calculators/prosperity/containers/intro';
import StepOne from '../calculators/prosperity/containers/step-one';
import StepTwo from '../calculators/prosperity/containers/step-two';
import StepThree from '../calculators/prosperity/containers/step-three';
import StepFour from '../calculators/prosperity/containers/step-four';
import StepFive from '../calculators/prosperity/containers/step-five';
import StepSix from '../calculators/prosperity/containers/step-six';
import StepSeven from '../calculators/prosperity/containers/step-seven';
import StepEight from '../calculators/prosperity/containers/step-eight';
import StepNine from '../calculators/prosperity/containers/step-nine';
import Summary from '../calculators/prosperity/containers/summary';
import Assessment from '../calculators/prosperity/containers/assessment';
import ContactEmail from '../calculators/prosperity/containers/contact-email';
import ContactCoach from '../calculators/prosperity/containers/contact-coach';
import ThankYouCoach from '../calculators/prosperity/containers/thank-you-coach';
import ThankYouEmail from '../calculators/prosperity/containers/thank-you-email';

export const name = 'Prosperity Planner';

export const inNavigation = true;

export const redirectFromSteps = true;

export const routes = [
    {
        path: Routes.HOME,
        component: Intro,
        pagination: false,
        progressBar: false
    },
    {
        path: Routes.STEPONE,
        component: StepOne,
        pagination: {
            previous: false,
            next: {
                type: 'submit'
            }
        }
    },
    {
        path: Routes.STEPTWO,
        component: StepTwo,
        pagination: {
            next: {
                type: 'submit'
            }
        }
    },
    {
        path: Routes.STEPTHREE,
        component: StepThree,
        pagination: {
            next: {
                type: 'submit'
            }
        }
    },
    {
        path: Routes.STEPFOUR,
        component: StepFour,
        pagination: {
            next: false
        }
    },
    {
        path: Routes.STEPFIVE,
        component: StepFive,
        pagination: {
            next: {
                type: 'submit'
            }
        }
    },
    {
        path: Routes.STEPSIX,
        component: StepSix,
        pagination: {
            next: {
                type: 'submit'
            }
        }
    },
    {
        path: Routes.STEPSEVEN,
        component: StepSeven,
        pagination: {
            next: {
                type: 'submit'
            }
        }
    },
    {
        path: Routes.STEPEIGHT,
        component: StepEight,
        pagination: {
            next: {
                type: 'submit'
            }
        }
    },
    {
        path: Routes.STEPNINE,
        component: StepNine,
        pagination: {
            next: {
                type: 'submit'
            }
        }
    },
    {
        path: Routes.SUMMARY,
        component: Summary,
        pagination: {
            previous: false,
            next: {
                tracking: () => trackingEvent({
                    eventAction: 'Prosperity Planner - Summary',
                    eventLabel: 'Summary of Prosperity Plan'
                })

            }
        },
        progressBar: false
    },
    {
        path: Routes.ASSESSMENT,
        component: Assessment,
        pagination: false,
        progressBar: false
    },
    {
        path: Routes.CONTACTCOACH,
        component: ContactCoach,
        pagination: false,
        progressBar: false
    },
    {
        path: Routes.CONTACTEMAIL,
        component: ContactEmail,
        pagination: false,
        progressBar: false
    },
    {
        path: Routes.THANKYOUCOACH,
        component: ThankYouCoach,
        pagination: false,
        progressBar: false
    },
    {
        path: Routes.THANKYOUEMAIL,
        component: ThankYouEmail,
        pagination: false,
        progressBar: false
    }
];
